// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "257") return "customize.9a84590c.js";
if (chunkId === "911") return "dingtalk-jsapi.v3.0.20.js";
if (chunkId === "69") return "sentry-react.v7.63.0.js";
if (chunkId === "549") return "ali-oss.v6.17.1.js";
if (chunkId === "154") return "i18next.v23.4.4.js";
if (chunkId === "829") return "light-component.v0.1.34-beta.2.1fa6b2ff.js";
  // return url for filenames based on template
  return "" + chunkId + ".javascript"
}